import { giphyLightCharcoal, giphyLightGrey, giphyLightestGrey } from '@giphy/colors'
import { useContext } from 'react'
import styled from 'styled-components'
import { IconButton } from 'ui'
import { CopilotContext } from '../context'
import { CopilotAlertContext } from '../contexts/alert'
import { CopilotDropdownContext } from '../contexts/dropdown'
import { CopilotSidebarContext } from '../contexts/sidebar'
import { Button } from '../preset/style'

const Option = styled.div`
    color: ${giphyLightGrey};
    cursor: pointer;
    display: flex;
    transition: color 0.1s ease-out;

    &:hover {
        color: ${giphyLightestGrey};
    }
`

type Props = {
    className?: string
}

const CopilotDropdownOptions = ({ className }: Props) => {
    const { activePresetId, resetPreset } = useContext(CopilotContext)
    const { showAlert } = useContext(CopilotAlertContext)
    const { openSidebar } = useContext(CopilotSidebarContext)
    const { closeDropdown } = useContext(CopilotDropdownContext)

    async function onResetClick() {
        closeDropdown()

        if (activePresetId) {
            await showAlert('reset')
        }

        resetPreset()
    }

    function onManageClick() {
        openSidebar()
        closeDropdown()
    }

    return (
        <div className={className}>
            <Option onClick={onResetClick}>
                <Button color="transparent" size="small" textColor="inherit">
                    Reset All Fields
                </Button>
                <IconButton color={giphyLightCharcoal} icon="reset" inverted size="small" />
            </Option>
            <Option onClick={onManageClick}>
                <Button color="transparent" size="small" textColor="inherit">
                    Import + Manage Presets
                </Button>
                <IconButton color={giphyLightCharcoal} icon="flash" iconScale={1.3} inverted size="small" />
            </Option>
        </div>
    )
}

export default CopilotDropdownOptions
